<div class="contact-modal">

  <div class="content">

    <div class="header">
      <h5>
        <img src="../../../../../assets/icons/phone-outgoing.svg" alt="" />
        {{ modalTitleKey | translate }} {{ organizationName ? ' ' + organizationName : '' }}
      </h5>
      <div class="modal-exit">
        <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
      </div>
    </div>

    <div class="contact-box">
      <p>{{ modalMessageKey | translate: (organizationName ? {org: organizationName} : {}) }}</p>
    </div>

    <p class="phone-box" *ngIf="!Loading">
      <span class="title">{{ 'customerServiceNumber' | translate }}</span>
      <span class="phone">{{contactServiceData.phoneNumber}}</span>
      <span class="title">{{ 'email_address' | translate }}:</span>
      <span class="phone">{{contactServiceData.email}}</span>
      <span class="date">{{ workingHoursKey | translate }}</span>
    </p>
    <p-skeleton *ngIf="Loading" width="100%" borderRadius="6px" height="180px" />

  </div>
</div>